"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.space = exports.colorHash = exports.getContrastTIQHex = exports.getContrastYIQRGB = exports.hexToRgb = exports.rgbToHex = exports.componentToHex = exports.hexAlpha = exports.color = void 0;
var theme_get_1 = require("@styled-system/theme-get");
var theme_1 = require("./theme");
var color = function (name, opacity) {
    return function (props) {
        var value = (0, theme_get_1.themeGet)("colors.".concat(name))(props);
        if (opacity === undefined)
            return value;
        var _a = (0, exports.hexToRgb)(value), r = _a.r, g = _a.g, b = _a.b;
        return "rgba(".concat([r, g, b].join(","), ", ").concat(opacity, ")");
    };
};
exports.color = color;
var hexAlpha = function (color, opacity) {
    var clampedOpacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + clampedOpacity.toString(16).toUpperCase();
};
exports.hexAlpha = hexAlpha;
var componentToHex = function (value) {
    var hex = value.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
};
exports.componentToHex = componentToHex;
var rgbToHex = function (r, g, b) {
    return "#".concat((0, exports.componentToHex)(r)).concat((0, exports.componentToHex)(g)).concat((0, exports.componentToHex)(b));
};
exports.rgbToHex = rgbToHex;
var hexToRgb = function (value) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(value);
    if (!result) {
        throw new Error("Invalid input ".concat(value));
    }
    return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    };
};
exports.hexToRgb = hexToRgb;
var getContrastYIQRGB = function (_a) {
    var r = _a.r, g = _a.g, b = _a.b, a = _a.a;
    if (a === 0)
        return "black";
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "black" : "white";
};
exports.getContrastYIQRGB = getContrastYIQRGB;
var getContrastTIQHex = function (value) {
    return (0, exports.getContrastYIQRGB)(__assign({}, (0, exports.hexToRgb)(value)));
};
exports.getContrastTIQHex = getContrastTIQHex;
var colorHash = function (string) {
    var code = 0;
    for (var i = 0; i < string.length; i++) {
        code = string.charCodeAt(i) + ((code << 5) - code);
    }
    var c = (code & 0x00ffffff).toString(16).toUpperCase();
    var hex = "00000".substring(0, 6 - c.length) + c;
    return "#".concat(hex);
};
exports.colorHash = colorHash;
var space = function (index) {
    return theme_1.SPACE_SCALE[index];
};
exports.space = space;
//# sourceMappingURL=utils.js.map